import { usePartnerRoleRepository } from '@ayocore/erp/crm/client/rpc';
import { createRepositoryFilter } from '@ayocore/platform/client/components/RepositoryTable/createRepositoryFilter';
import type { PartnerRepository } from '@ayocore/erp/crm/server/repositories/PartnerRepository';

type RoleRepo = ReturnType<typeof usePartnerRoleRepository>;

/**
 * Фильтр партнёров по типу (роли): клиент / поставщик / подрядчик / перевозчик (single).
 * Источник опций — справочник активных ролей `crm_partner_roles`, плюс пункт
 * «Без типа» для партнёров без единой роли.
 */
export const FilterByPartnerType = createRepositoryFilter<PartnerRepository, RoleRepo>({
  name: 'partner_type',
  placeholder: 'Тип партнёра...',
  width: 170,
  source: () => usePartnerRoleRepository().where('is_active', true).orderBy('name', 'asc'),
  displayField: 'name',
  by: (repo, id) => repo.filterByRole(id),
  without: { label: 'Без типа', apply: repo => repo.filterWithoutRole() },
});
